const ThumbBucketProfileStyleType = Object.freeze({
  Digging: 'Digging',
  Ditching: 'Ditching',
  TiltDitching: 'TiltDitching',
});

export { ThumbBucketProfileStyleType };
